// extracted by mini-css-extract-plugin
module.exports = {"homeCategoriesMain":"home-categories_homeCategoriesMain__qDEd_","categoriesRepeaterDiv":"home-categories_categoriesRepeaterDiv__lJ_Dt"};